module.exports = __webpack_public_path__ + "img/desktop3.f66ccce6.svg";